import * as Yup from 'yup';

const LoginSchema = Yup.object().shape({
  email: Yup.string()
    .email('Email must be valid email address')
    .required('Email is required'),
  password: Yup.string().required('Password is required'),
});
export default LoginSchema;
